import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useWizardWithData } from '../../../../../../../../core/hooks/WizardWithData';
import { AodRuleWizardValues } from '../../types';
import { WizardFinalizeBtn } from './WizardFinalizeBtn';

export function WizardActionsRHF() {
  const { previousStep } = useWizardWithData<AodRuleWizardValues>();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', mt: 5, gap: 2 }}>
      <Button color="warning" variant="outlined" onClick={previousStep}>
        <FormattedMessage id="common.wizard.back" defaultMessage="Atrás" />
      </Button>
      <Button type="submit" variant="outlined" startIcon={<ArrowForwardIcon />}>
        <FormattedMessage id="common.wizard.next" defaultMessage="Siguiente" />
      </Button>
      <WizardFinalizeBtn />
    </Box>
  );
}
